module.exports = __webpack_public_path__ + "static/media/shape5.3943f0b6.svg";